import { render, staticRenderFns } from "./CertificateListFisik.vue?vue&type=template&id=cb6f245c&"
import script from "./CertificateListFisik.vue?vue&type=script&lang=js&"
export * from "./CertificateListFisik.vue?vue&type=script&lang=js&"
import style0 from "./CertificateListFisik.vue?vue&type=style&index=0&id=cb6f245c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports